import { useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios'
import { convertObjectSnakeToCamel } from '../utils/text';

type Props = {
  id?: string
}

export const useGetContent = (props: Props) => {
  const {id} = props
  const [response, setResponse] = useState<any>(null)
  const [error, setError] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!id) return
    // const headers = {
    //   'x-api-key': process.env.REACT_APP_API_KEY,
    // }
    axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/torimawari?id=${id}`,
      // { headers }
    ).then(res => {
      const dataForLocal = {...res.data, image_url: res.data.image_url.replace('http://minio', 'http://localhost')} // FIXME: ローカルテストよう
      const formattedResponse = convertObjectSnakeToCamel(dataForLocal) // FIXME: ローカルテストよう
      // const formattedResponse = convertObjectSnakeToCamel(res.data)
      setResponse(formattedResponse)
      setIsLoading(false)
    }).catch(e => {
      console.log('axiosのエラー: ', e.response)
      setError(e.response)
      setIsLoading(false)
    })
  }, [id])

  return {data: response, error, isLoading}
}